import { registerRootComparator, getRootComparator, getCompareFunctionFactory } from './registry';
import { FIRST_AFTER_SECOND, FIRST_BEFORE_SECOND, DO_NOT_SWAP, sort } from './engine';
export { registerRootComparator, getRootComparator, getCompareFunctionFactory, FIRST_AFTER_SECOND, FIRST_BEFORE_SECOND, DO_NOT_SWAP, sort };


//////////////////
// WEBPACK FOOTER
// ./node_modules/handsontable/es/plugins/columnSorting/sortService/index.js
// module id = 284
// module chunks = 0